import { DescriptionSize } from 'aid-form-service';

export const CollapseSizes = {
  [DescriptionSize.SMALL]: 12,
  [DescriptionSize.MIDDLE]: 16,
  [DescriptionSize.BIGGER]: 20,
};
